import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { PaperworkPage } from "web_myplann/Profile/Pages/PaperworkPage";
import { PaperworkV2Page } from "web_myplann/Profile/Pages/PaperworkV2Page";

export const PaperworkPageSwitch: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <PaperworkV2Page /> : <PaperworkPage />;
};
